import { Pipe, PipeTransform, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from './config';

@Pipe({
  name: 'cdnPrefix',
})
export class CdnPrefixPipe implements PipeTransform {
  constructor(@Inject(ENVIRONMENT_CONFIG) private _config: EnvironmentConfig) {}

  transform(path: string): string {
    return Location.joinWithSlash(
      `${this._config.api.gateways.cdn}${
        this._config.api.gateways.cdn !== '' ? 'spa/chcp/' : ''
      }`,
      path,
    );
  }
}
